import $ from 'jquery';

class Product {

    params = {
        loadingClass: 'woocommerce-input-toggle--loading',
        enabledClass: 'woocommerce-input-toggle--enabled',
        disabledClass: 'woocommerce-input-toggle--disabled'
    };

    constructor() {
        this.init();
    }

    init() {
        $('table.wc_gateways').sortable({
            items: 'tr',
            axis: 'y',
            cursor: 'move',
            scrollSensitivity: 40,
            forcePlaceholderSize: true,
            helper: 'clone',
            opacity: 0.65,
            placeholder: 'wc-metabox-sortable-placeholder',
            start(event, ui) {
                ui.item.css('background-color', '#f6f6f6');
            },
            stop(event, ui) {
                ui.item.removeAttr('style');
            },
            change: () => this.settingChanged()
        });

        $('table.wc_gateways').find('.wc-move-down, .wc-move-up').on('click', this.moveGateway.bind(this));
        $('#stripe_product_data .wc-stripe-product-gateway-enabled').on('click', this.enableGateway.bind(this));
        $('.wc-stripe-save-product-data').on('click', this.save.bind(this));
        $('#stripe_product_data select').on('change', this.settingChanged.bind(this));
    }

    moveGateway(e) {
        const $row = $(e.currentTarget).closest('tr');

        if ($(e.currentTarget).is('.wc-move-down')) {
            const $next = $row.next('tr');
            if ($next.length) {
                $next.after($row);
            }
        } else {
            const $prev = $row.prev('tr');
            if ($prev.length) {
                $prev.before($row);
            }
        }
        this.settingChanged();
    }

    settingChanged() {
        $('#wc_stripe_update_product').val('true');
    }

    enableGateway(e) {
        e.preventDefault();
        const $el = $(e.currentTarget);
        const $row = $el.closest('tr');
        const $toggle = $el.find('.woocommerce-input-toggle');

        $toggle.addClass(this.params.loadingClass);

        $.ajax({
            url: wc_stripe_product_params.routes.enable_gateway,
            method: 'POST',
            dataType: 'json',
            data: {
                _wpnonce: wc_stripe_product_params._wpnonce,
                product_id: $('#post_ID').val(),
                gateway_id: $row.data('gateway_id')
            }
        }).done((response) => {
            $toggle.removeClass(this.params.loadingClass);
            if (response.enabled) {
                $toggle.addClass(this.params.enabledClass).removeClass(this.params.disabledClass);
            } else {
                $toggle.removeClass(this.params.enabledClass).addClass(this.params.disabledClass);
            }
        }).fail(() => {
            $toggle.removeClass(this.params.loadingClass);
        });
    }

    save(e) {
        e.preventDefault();
        const $button = $(e.currentTarget);

        const gateways = $('[name^="stripe_gateway_order"]').map((i, el) => $(el).val()).get();
        const charge_types = $('[name^="stripe_capture_type"]').map((i, el) => ({
            gateway: $(el).closest('tr').data('gateway_id'),
            value: $(el).val()
        })).get();

        $button.toggleClass('disabled').prop('disabled', true);
        $button.next('.spinner').toggleClass('is-active');

        $.ajax({
            url: wc_stripe_product_params.routes.save,
            method: 'POST',
            dataType: 'json',
            data: {
                _wpnonce: wc_stripe_product_params._wpnonce,
                gateways,
                charge_types,
                product_id: $('#post_ID').val(),
                position: $('#_stripe_button_position').val()
            }
        }).done(() => {
            $button.toggleClass('disabled').prop('disabled', false);
            $button.next('.spinner').toggleClass('is-active');
        }).fail(() => {
            $button.toggleClass('disabled').prop('disabled', false);
            $button.next('.spinner').toggleClass('is-active');
        });
    }
}

$(() => {
    new Product();
})
